import { render, staticRenderFns } from "./SettingsStockLocationsPage.vue?vue&type=template&id=61d16fc0"
import script from "./SettingsStockLocationsPage.vue?vue&type=script&lang=js"
export * from "./SettingsStockLocationsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports